import React, { memo, useCallback } from 'react'

import { classnames, CubeOutline, Icon, Upload2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, oneOfType, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { clearSettings as clearAnimateSettings } from 'Pods/ThreeDStudio/Store/actions/animateSettings'
import { setInputThreeD } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { clearSettings as clearRemeshSettings } from 'Pods/ThreeDStudio/Store/actions/remeshSettings'
import { clearSettings as clearRenderSettings } from 'Pods/ThreeDStudio/Store/actions/renderSettings'
import { clearSettings as clearTextureSettings } from 'Pods/ThreeDStudio/Store/actions/textureSettings'

const getUrlExtension = (url) => {
  const pathname = String(url ?? '').split('?')[0]
  const filename = pathname.slice(pathname.lastIndexOf('/') + 1)
  const parts = filename.split('.')
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : undefined
}

const placeholderIconSize = { height: '56px', width: '56px' }

function UploadedModelCard({ asset, isActive = false }) {
  const t = useTranslation()
  const { assetId, fileUrl, previewUrl } = asset
  const label = t('viewerSidebar.enhance.variations.uploaded')

  const handleClick = useCallback(() => {
    clearAnimateSettings()
    clearRemeshSettings()
    clearRenderSettings()
    clearTextureSettings()
    setInputThreeD(assetId, fileUrl, undefined, getUrlExtension(fileUrl))
  }, [assetId, fileUrl])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleClick()
    }
  }, [handleClick])

  return (
    <div
      className={classnames('variation-card', isActive && 'variation-card--active')}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      {previewUrl ? (
        <img
          className="variation-card__image variation-card__image--contain"
          src={previewUrl}
          alt={label}
        />
      ) : (
        <span className="variation-card__placeholder" aria-hidden="true">
          <Icon notSpaced svgComponent={CubeOutline} color="dark" size={placeholderIconSize} />
        </span>
      )}
      <span className="variation-card__type cgt-caption-semibold">
        <Icon notSpaced svgComponent={Upload2} color="dark" size={iconSize} />
        {label}
      </span>
    </div>
  )
}

UploadedModelCard.propTypes = {
  asset: shape({
    assetId: oneOfType([string, number]),
    fileUrl: string,
    previewUrl: string,
  }).isRequired,
  isActive: bool,
}

export default memo(UploadedModelCard)
